import React, { useEffect, useState } from 'react';
import useGetNtxSettings from '../../../hooks/NTX/useGetNtxSettings';
import { type SettingsList } from '../../../store/NTX/Settings/settingsModels';
import { useTranslation } from 'react-i18next';
import CustomAlert from '../../../components/Shared/Alert/CustomAlert';
import { useAppDispatch } from '../../../store/hooks';
import { GetNtxSettingsList, UpdateNtxSettingValue } from '../../../store/NTX/Settings/settingsSlice';
import { Form } from 'react-bootstrap';

// interface props {
//   settingId: string;
//   settingType: 'radio' | 'input' | 'checkbox';
//   onClose: () => void;
// }

// const UpdateNtxSettings: React.FC<props> = props => {
//   const dispatch = useAppDispatch();
//   const { t, i18n } = useTranslation();
//   // console.log(props.settingType);

//   const [settingState, setSettingState] = useState<SettingsList[]>([]);
//   const [selectedValue, setSelectedValue] = useState<string | null>(null);
//   const [textValue, setTextValue] = useState<string>(''); // For text input value

//   const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
//   const { SettingsLiat } = useGetNtxSettings();

//   useEffect(() => {
//     var state = SettingsLiat?.filter(f => f.id === props.settingId);
//     setSettingState(state);
//   }, [SettingsLiat, props.settingId]);

//   useEffect(() => {
//     if (props.settingType === 'radio') {
//       const value: any = settingState[0]?.getFlexValueList?.find(
//         f => f.id?.toLowerCase() === settingState[0]?.value?.toLowerCase()
//       )?.id;
//       setSelectedValue(value);
//     } else if (props.settingType === 'input') {
//       setTextValue(settingState[0]?.value || '');
//     }
//   }, [settingState, props.settingType]);

//   const submitNtxSetting = () => {
//     try {
//       setIsSubmitting(true);

//       const settingValue = props.settingType === 'radio' ? selectedValue : textValue;

//       dispatch(
//         UpdateNtxSettingValue({
//           organizationSettingId: settingState[0].id,
//           // settingValue: selectedValue,
//           settingValue
//         })
//       )
//         .unwrap()
//         .then(res => {
//           if (res?.succeeded === true) {
//             CustomAlert({ action: 'Edit', msg: 'تم تعديل الإعداد بنجاح' });
//             dispatch(GetNtxSettingsList());
//             document.getElementById('closeModalForm')?.click();
//             setIsSubmitting(false);
//           } else {
//             setIsSubmitting(false);
//             CustomAlert({ action: 'Error', msg: res?.message });
//           }
//         })
//         .catch((error: any) => {
//           CustomAlert({ action: 'Error' });
//         });
//     } catch (err: any) {
//       console.log(err);
//     }
//   };

//   return (
//     <>
//       <div className='text-center bg-inverse bg-opacity-10 rounded-0 p-2 fw-bold fs-5 mb-2'>
//         {i18n.language === 'ar'
//           ? SettingsLiat?.find(f => f.id === props.settingId)?.name2
//           : SettingsLiat?.find(f => f.id === props.settingId)?.name}
//       </div>
//       {props.settingType === 'input' ? (
//         <Form.Control
//           className='form-control fw-bold text-center fs-4'
//           type='text'
//           autoComplete='off'
//           value={textValue}
//           onChange={e => setTextValue(e.target.value)}
//         />
//       ) : (
//         <>
//           <hr className='mt-2 mb-2' />
//           {settingState &&
//             settingState?.map(item =>
//               item.getFlexValueList?.map(value => (
//                 <div key={value.id}>
//                   <div className='row align-items-center'>
//                     <div className='col-8 pt-1 pb-1'>{i18n.language === 'ar' ? value.name2 : value.name}</div>
//                     <div className='col-4 d-flex align-items-center'>
//                       <div className='form-check form-switch ms-auto'>
//                         <input
//                           type='radio'
//                           className='form-check-input me-2'
//                           name={value.id}
//                           checked={value.id === selectedValue}
//                           onChange={e => setSelectedValue(e.target.name)}
//                         />
//                         <label className='form-check-label' htmlFor='shippingFree'>
//                           &nbsp;
//                         </label>
//                       </div>
//                     </div>
//                   </div>

//                   <hr className='mt-2 mb-2' />
//                 </div>
//               ))
//             )}
//         </>
//       )}

//       <div className='row mt-4'>
//         <div className='col-lg-6'>
//           <button
//             disabled={isSubmitting}
//             type='button'
//             className='btn btn-lg btn-theme w-100'
//             onClick={() => submitNtxSetting()}
//           >
//             {isSubmitting ? (
//               <div className='spinner-border spinner-border-sm me-2'></div>
//             ) : (
//               <i className='fa fa-save fa-fw me-1'></i>
//             )}
//             {t('Save')}
//           </button>
//         </div>
//         <div className='col-lg-6'>
//           <button type='button' className=' btn btn-lg btn-default w-100' onClick={props.onClose}>
//             <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default UpdateNtxSettings;

interface Props {
  settingId: string;
  settingType: 'radio' | 'input' | 'checkbox';
  onClose: () => void;
}

const UpdateNtxSettings: React.FC<Props> = ({ settingId, settingType, onClose }) => {
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();
  const [settingState, setSettingState] = useState<SettingsList[]>([]);
  const [selectedValue, setSelectedValue] = useState<string | null>(null); // For radio
  const [textValue, setTextValue] = useState<string>(''); // For text input
  const [checkboxValue, setCheckboxValue] = useState<string>('0'); // For checkbox (0 or 1)
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { SettingsLiat } = useGetNtxSettings();

  useEffect(() => {
    const state = SettingsLiat?.filter(f => f.id === settingId);
    setSettingState(state || []);
  }, [SettingsLiat, settingId]);
  // console.log(settingState);

  useEffect(() => {
    if (settingState.length > 0) {
      if (settingType === 'radio') {
        const value = settingState[0]?.getFlexValueList?.find(
          f => f.id?.toLowerCase() === settingState[0]?.value?.toLowerCase()
        )?.id;
        setSelectedValue(value || null);
      } else if (settingType === 'input') {
        setTextValue(settingState[0]?.value || '');
      } else if (settingType === 'checkbox') {
        // Initialize checkbox value as '0' or '1'
        setCheckboxValue(settingState[0]?.value === '1' ? '1' : '0');
      }
    }
  }, [settingState, settingType]);

  const handleCheckboxChange = () => {
    setCheckboxValue(prev => (prev === '1' ? '0' : '1'));
  };
  console.log(  checkboxValue);

  const submitNtxSetting = () => {
    try {
      setIsSubmitting(true);

      let settingValue: string | null;
      if (settingType === 'radio') {
        settingValue = selectedValue;
      } else if (settingType === 'input') {
        settingValue = textValue;
      } else {
        // For checkbox, join selected values into a comma-separated string
        settingValue = checkboxValue; // Send '0' or '1'
      }

      dispatch(
        UpdateNtxSettingValue({
          organizationSettingId: settingState[0].id,
          settingValue
        })
      )
        .unwrap()
        .then(res => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Edit', msg: 'تم تعديل الإعداد بنجاح' });
            dispatch(GetNtxSettingsList());
            document.getElementById('closeModalForm')?.click();
            setIsSubmitting(false);
          } else {
            setIsSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          setIsSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    } catch (err: any) {
      console.log(err);
      setIsSubmitting(false);
      CustomAlert({ action: 'Error' });
    }
  };

  // console.log(settingType);

  return (
    <>
      <div className='text-center bg-inverse bg-opacity-10 rounded-0 p-2 fw-bold fs-5 mb-2'>
        {i18n.language === 'ar'
          ? SettingsLiat?.find(f => f.id === settingId)?.name2
          : SettingsLiat?.find(f => f.id === settingId)?.name}
      </div>

      {settingType === 'input' ? (
        <Form.Control
          className='form-control fw-bold text-center fs-4'
          type='text'
          autoComplete='off'
          value={textValue}
          onChange={e => setTextValue(e.target.value)}
        />
      ) : settingType === 'radio' ? (
        <>
          <hr className='mt-2 mb-2' />
          {settingState?.map(item =>
            item.getFlexValueList?.map(value => (
              <div key={value.id}>
                <div className='row align-items-center'>
                  <div className='col-8 pt-1 pb-1'>{i18n.language === 'ar' ? value.name2 : value.name}</div>
                  <div className='col-4 d-flex align-items-center'>
                    <div className='form-check form-switch ms-auto'>
                      <input
                        type='radio'
                        className='form-check-input me-2'
                        name={value.id}
                        checked={value.id === selectedValue}
                        onChange={e => setSelectedValue(e.target?.name)}
                      />
                      <label className='form-check-label' htmlFor={value.id}></label>
                    </div>
                  </div>
                </div>
                <hr className='mt-2 mb-2' />
              </div>
            ))
          )}
        </>
      ) : settingType === 'checkbox' ? (
        <>
          <hr className='mt-2 mb-2' />
          <div className='row align-items-center'>
            <div className='col-8 pt-1 pb-1'>
              {i18n.language === 'ar' ? settingState[0]?.name2 || 'Checkbox' : settingState[0]?.name || 'Checkbox'}
            </div>
            <div className='col-4 d-flex align-items-center'>
              <div className='form-check ms-auto'>
                <input
                  type='checkbox'
                  className='form-check-input me-2'
                  id={settingId}
                  checked={checkboxValue === '1'}
                  onChange={handleCheckboxChange}
                />
                <label className='form-check-label' htmlFor={settingId}></label>
              </div>
            </div>
          </div>
          <hr className='mt-2 mb-2' />
        </>
      ) : null}

      <div className='row mt-4'>
        <div className='col-lg-6'>
          <button
            disabled={isSubmitting}
            type='button'
            className='btn btn-lg btn-theme w-100'
            onClick={submitNtxSetting}
          >
            {isSubmitting ? (
              <div className='spinner-border spinner-border-sm me-2'></div>
            ) : (
              <i className='fa fa-save fa-fw me-1'></i>
            )}
            {t('Save')}
          </button>
        </div>
        <div className='col-lg-6'>
          <button type='button' className='btn btn-lg btn-default w-100' onClick={onClose}>
            <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
          </button>
        </div>
      </div>
    </>
  );
};

export default UpdateNtxSettings;
